import React, { useEffect, useRef } from 'react';
import * as Motion from 'motion/react';
import useDialogBox from '../../hooks/useDialogBox';
import { animationStaggeredItem } from '../../animations';
import './index.scss';

const { motion } = Motion;


const DialogBox = () => {
  const dialogBoxContainerRef = useRef<HTMLDivElement>(null);
  const { title, content, actions, resetDialogBox } = useDialogBox();

  const generateActionButtons = () => {
    if (actions) {
      return actions.map((action, index) => {
        return (
          <button className={`action-type-${action.type}`} key={action.title} onClick={() => {
            action.action()
          }}>
            {action.title}
          </button>
        )
      });
    }
  };

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        dialogBoxContainerRef.current &&
        !dialogBoxContainerRef.current.contains(event.target as Node)
      ) {
        resetDialogBox();
      }
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  if (title && content) {
    return (
      <motion.div variants={animationStaggeredItem} className={'dialog-box-screen-container'}>
        <div ref={dialogBoxContainerRef} className={'dialog-box-wrapper'}>
          <div className={'dialog-box-header'}>
            <h1 className={'dialog-box-title'}>{title}</h1>
          </div>

          <div className={'dialog-box-content'}>
            {content}
          </div>

          <div className={'dialog-box-footer'}>
            {
              generateActionButtons()
            }
          </div>
        </div>
      </motion.div>
    );
  }

  return <div></div>;
};

export default DialogBox;
